import React, { Fragment } from "react";
import Drawer from "@material-ui/core/Drawer";


const BottomDrawer = ({ children, open, style, height, maxHeight, marginTop }) => {

    const paperStyle = {
        overflow: "visible",
        zIndex: 1301,
        height: height || '92%',
        maxHeight: maxHeight || '92%',
        marginTop: marginTop || 'none',
        borderBottom: "1px solid #000",
        ...(style || {})
    }

    return (
        <Fragment>
            <Drawer
                id="bottomDrawer"
                PaperProps={{ style: { ...paperStyle } }}
                variant="persistent"
                anchor="bottom"
                open={open}
                // transitionDuration={{enter: 2000, exit: 3000}}
                // SlideProps={{
                //     direction: "up", 
                //     timeout: {
                //         enter: 10000,
                //         exit: 10000,
                //     },
                //   }}
              
            >
                {children}
            </Drawer>
        </Fragment>
    );
};

export default BottomDrawer;


